import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { DataProvider } from './context/DataContext';
import { ThemeProvider } from './context/ThemeContext';
import { I18nProvider } from './context/I18nContext';
import MobileBottomNav from './components/MobileBottomNav';
import ImpersonationBanner from './components/ImpersonationBanner';
import ScrollToTop from './components/ScrollToTop';
import ChatWidget from './components/chatbot/ChatWidget';
import HomePage from './pages/HomePage';
import MainCategoryPage from './pages/MainCategoryPage';
import CategoryPage from './pages/CategoryPage';
import SubCategoryPage from './pages/SubCategoryPage';
import ProductDetailPage from './pages/ProductDetailPage';
import SupplierProfilePage from './pages/SupplierProfilePage';
import SearchResultsPage from './pages/SearchResultsPage';
import AiSearchResultsPage from './pages/AiSearchResultsPage';
import VendorRegister from './pages/VendorRegister';
import VendorDashboard from './pages/VendorDashboard';
import CustomerRegister from './pages/CustomerRegister';
import AccountPage from './pages/AccountPage';
import CustomerMessagesPage from './pages/CustomerMessagesPage';
import VendorMessagesPage from './pages/VendorMessagesPage';
import ComparePage from './pages/ComparePage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import BusinessDirectoryPage from './pages/BusinessDirectoryPage';
import InvoicePage from './pages/InvoicePage';
import CmsPage from './pages/CmsPage';
import DeleteAccountPage from './pages/DeleteAccountPage';
import SEOHead from './components/SEOHead';
import LoginHub from './pages/LoginHub';
import RegisterHub from './pages/RegisterHub';

function App() {
  return (
    <div className="App bg-white dark:bg-[#0b1220] text-gray-900 dark:text-gray-100 min-h-screen transition-colors">
      <ThemeProvider>
        <I18nProvider>
          <DataProvider>
            <BrowserRouter>
              <ScrollToTop />
              <SEOHead />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/main/:slug" element={<MainCategoryPage />} />
                <Route path="/category/:slug" element={<CategoryPage />} />
                <Route path="/subcategory/:slug" element={<SubCategoryPage />} />
                <Route path="/product/:id" element={<ProductDetailPage />} />
                <Route path="/supplier/:id" element={<SupplierProfilePage />} />
                <Route path="/vendor/register" element={<VendorRegister />} />
                <Route path="/vendor/dashboard" element={<VendorDashboard />} />
                <Route path="/vendor/login" element={<LoginHub />} />
                <Route path="/customer/register" element={<CustomerRegister />} />
                <Route path="/register" element={<RegisterHub />} />
                <Route path="/login" element={<LoginHub />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/account/messages" element={<CustomerMessagesPage />} />
                <Route path="/vendor/messages" element={<VendorMessagesPage />} />
                <Route path="/compare" element={<ComparePage />} />
                <Route path="/vendor/:id" element={<SupplierProfilePage />} />
                <Route path="/search" element={<SearchResultsPage />} />
                <Route path="/ai-search" element={<AiSearchResultsPage />} />
                <Route path="/directory" element={<BusinessDirectoryPage />} />
                {/* Legacy /service/* routes removed — redirect to directory so old links don't 404 */}
                <Route path="/service/*" element={<Navigate to="/directory" replace />} />
                <Route path="/vendor/invoices/:orderId" element={<InvoicePage />} />
                <Route path="/p/:slug" element={<CmsPage />} />
                <Route path="/delete-account" element={<DeleteAccountPage />} />
                <Route path="/account/delete" element={<DeleteAccountPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
              <MobileBottomNav />
              <ImpersonationBanner />
              <ChatWidget />
              <Toaster />
            </BrowserRouter>
          </DataProvider>
        </I18nProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
